"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findDiffs = exports.filterMap = void 0;
const filterMap = (source, fn) => {
    const output = [];
    source.forEach(item => {
        const result = fn(item);
        if (result !== false)
            output.push(result);
    });
    return output;
};
exports.filterMap = filterMap;
const findDiffs = (a1, a2) => {
    return {
        added: a1.filter(it => !a2.includes(it)),
        removed: a2.filter(it => !a1.includes(it)),
    };
};
exports.findDiffs = findDiffs;
